import { User } from "oidc-client-ts";

export enum FEATURE_FLAGS {
  HeritageAndEthnicity = "HeritageAndEthnicity",
  "HeritageAndEthnicity-BreakdownsAndJobFilters" = "HeritageAndEthnicity-BreakdownsAndJobFilters",
  ProfileMakeupDetails = "ProfileMakeupDetails",
  JoiningCDProcess = "JoiningCDProcess",
  AddOnCheckout = "AddOnCheckout",
  FilmmakersTrial = "FilmmakersTrial",
  FilmmakersJobsEmails = "FilmmakersJobsEmails",
  SelfTapes = "SelfTapes",
  AudioClipRequest = "AudioClipRequest",
  AgencyJobFeedSettings = "AgencyJobFeedSettings",
  RoleCast = "RoleCast",
  ECPModalVariant = "ECPModalVariant",
  GradsJoiningSignUp = "GradsJoiningSignUp",
  Grads2024Launch = "Grads2024Launch",
  VisasAndPermits = "VisasAndPermits",
  "PremiumYesNo-RoleCast" = "PremiumYesNo-RoleCast",
  "PremiumYesNo-MarkRoleAsCast" = "PremiumYesNo-MarkRoleAsCast",
  LinkingShortlists = "LinkingShortlists",
  ContinuousPaymentAuthorityCheckoutMessage = "ContinuousPaymentAuthorityCheckoutMessage",
  AllowSubscriptionCancellation = "AllowSubscriptionCancellation",
  SelfServeCancellation = "SelfServeCancellation",
  ConvertToGrad = "ConvertToGrad",
  CloseBreakdownEarly = "CloseBreakdownEarly",
  YPsPlayingAgeMin = "YPsPlayingAgeMin",
  FilmmakersSingleSignOn = "FilmmakersSingleSignOn",
}

export const buildUser = (thisUser: User | null | undefined) => {
  return thisUser
    ? {
        key: thisUser.profile.sub,
        name: thisUser.profile.name,
        email: thisUser.profile.email,
        anonymous: Object.keys(thisUser).length === 0,
      }
    : {
        key: "anonymous",
        name: "",
        email: "",
        anonymous: true,
      };
};
